<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="194" height="194" viewBox="0 0 194 194">
        <defs>
            <filter id="Ellipse_3" x="0" y="0" width="194" height="194" filterUnits="userSpaceOnUse">
                <feOffset input="SourceAlpha"/>
                <feGaussianBlur stdDeviation="7.5" result="blur"/>
                <feFlood flood-opacity="0.161"/>
                <feComposite operator="in" in2="blur"/>
                <feComposite in="SourceGraphic"/>
            </filter>
        </defs>
        <g id="Group_2038" data-name="Group 2038" transform="translate(22.499 22.5)">
            <g transform="matrix(1, 0, 0, 1, -22.5, -22.5)" filter="url(#Ellipse_3)">
                <circle id="Ellipse_3-2" data-name="Ellipse 3" cx="74.5" cy="74.5" r="74.5" transform="translate(22.5 22.5)" fill="#43c7f4"/>
            </g>
            <g id="Group_2036" data-name="Group 2036" transform="translate(34.731 35.19)">
                <path id="Path_619" data-name="Path 619" d="M697.273,143.132a38.838,38.838,0,1,1-38.839,38.838,38.84,38.84,0,0,1,38.839-38.838Z" transform="translate(-658.435 -143.132)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                <line id="Line_20" data-name="Line 20" y2="77.645" transform="translate(38.84)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                <line id="Line_21" data-name="Line 21" x2="77.645" transform="translate(0.017 38.839)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                <path id="Path_620" data-name="Path 620" d="M718.114,148.082c-5.931,5.354-16.02,8.879-27.47,8.879-11.423,0-21.493-3.51-27.429-8.843" transform="translate(-651.825 -136.286)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                <path id="Path_621" data-name="Path 621" d="M718.114,175.933c-5.931-5.354-16.02-8.879-27.47-8.879-11.423,0-21.493,3.508-27.429,8.843" transform="translate(-651.825 -110.05)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                <path id="Path_622" data-name="Path 622" d="M685.861,219.995a47.517,47.517,0,0,1-.079-76.593" transform="translate(-647.375 -142.758)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                <path id="Path_623" data-name="Path 623" d="M675.123,219.995A47.513,47.513,0,0,0,675.2,143.4" transform="translate(-635.358 -142.758)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
            </g>
        </g>
    </svg>



</template>

<script>
export default {
    name: "svg-location"
}
</script>

<style scoped lang="scss">
svg {
    transition: 200ms all ease-in-out;
    &:hover {
            transform: scale(1.1);
    }
}
</style>
